import { render } from "./TextElement.vue?vue&type=template&id=287782c2"
import script from "./TextElement.vue?vue&type=script&lang=js"
export * from "./TextElement.vue?vue&type=script&lang=js"

import "./TextElement.vue?vue&type=style&index=0&id=287782c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__